export default __webpack_public_path__ + "static/bodySectionBg-37278a751e4c8c8f8fc152fc27bd05a1.png";